import React from 'react';

export const Table: React.FC<{ className?: string; children: React.ReactNode }> = ({ className = '', children }) => (
  <table className={`min-w-full divide-y divide-neutral-200 dark:divide-neutral-700 ${className}`}>
    {children}
  </table>
);

export const TableHead: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <thead className="bg-neutral-50 dark:bg-neutral-900/60">
    {children}
  </thead>
);

export const TableBody: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <tbody className="bg-white dark:bg-neutral-900 divide-y divide-neutral-200 dark:divide-neutral-800">
    {children}
  </tbody>
);

export const TableRow: React.FC<{ className?: string; children: React.ReactNode }> = ({ className = '', children }) => (
  <tr className={`hover:bg-neutral-100 dark:hover:bg-neutral-800/60 transition-colors ${className}`}>
    {children}
  </tr>
);

export const TableCell: React.FC<{ className?: string; children: React.ReactNode }> = ({ className = '', children }) => (
  <td className={`px-4 py-2 whitespace-nowrap text-sm text-neutral-900 dark:text-neutral-100 ${className}`}>
    {children}
  </td>
); 